<div class="d-flex">
  <app-menu-toggle
    tooltip="Zoom out (hold)"
    icon="zoom-out"
    [active]="false"
    (click)="zoomOut(true); clearZoom()"
    (touchstart)="zoomOut(true)"
    (mousedown)="zoomOut($event.button === 0)"
    (mouseup)="clearZoom()"
    (mouseleave)="clearZoom()"
    (touchend)="clearZoom()"
    (touchcancel)="clearZoom()"
    (touchmove)="clearZoom()"
  >
  </app-menu-toggle>
  <app-menu-toggle
    tooltip="Zoom in (hold)"
    icon="zoom-in"
    [active]="false"
    (click)="zoomIn(true); clearZoom()"
    (touchstart)="zoomIn(true)"
    (mousedown)="zoomIn($event.button === 0)"
    (mouseup)="clearZoom()"
    (mouseleave)="clearZoom()"
    (touchend)="clearZoom()"
    (touchcancel)="clearZoom()"
    (touchmove)="clearZoom()"
  >
  </app-menu-toggle>
</div>
